import api from './api';
import {mapProjectDto} from "../dto/ProjectDTO";
import {mapUserProjectStats} from "../dto/UserProjectStats";


export const getProjectEntries = async () => {
    try {
        const res = await api.get(`/Project`);
        return res.data.map(mapProjectDto);
    } catch (err) {
        console.error("Error getting project entries:", err);
        throw err;
    }
};

export const getProjectStats = async ({userId, startDate, endDate}) => {
    try {
        const url = `/Project/Stats/${userId}`;
        const body = {
            StartDate: startDate,
            EndDate: endDate
        };
        const res = await api.post(url, body);
        return res.data.map(mapUserProjectStats);
    } catch (err) {
        console.error("Error getting project stats entries:", err);
        throw err;
    }
};